import Axios from '@/plugins/axios.js';
import { mkLeadsUrl } from '@/utils/config';
import { extractRspData } from '@/utils/product-case/model';

const prefix = `${mkLeadsUrl}/mk-leads/supplier/product-case`;

function post(url, data, config = {}) {
  return Axios({ url, method: 'POST', data, ...config });
}

function get(url, config = {}) {
  return Axios({ url, method: 'GET', ...config });
}

function appendLanguage(url, language) {
  const zlan = String(language || '').trim();
  return zlan ? `${url}?zlan=${encodeURIComponent(zlan)}` : url;
}

export function getProductCaseList(data) {
  return post(`${prefix}/list`, data);
}

export function getProductCaseDetail(data, language) {
  return post(appendLanguage(`${prefix}/detail`, language), data);
}

export function getProductCasePreviewExtra(data, language) {
  return post(appendLanguage(`${prefix}/preview-extra`, language), data);
}

export function batchSaveDraft(data) {
  return post(`${prefix}/batch-save-draft`, data);
}

export function batchSubmitReview(data) {
  return post(`${prefix}/batch-submit-review`, data);
}

export async function uploadSupplierProductImage(data) {
  const res = await post(`${mkLeadsUrl}/mk-leads/common/attach/upload`, data, {
    noMessage: true,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  const result = res && res.rspResult;
  const businessFailed = result
    ? (result.bizCode !== undefined ? result.bizCode !== 200 : result.resultCode !== 'SUCCESS')
    : res && typeof res.code === 'number' && res.code !== 200;
  const uploadData = extractRspData(res);
  if (businessFailed || typeof uploadData.hashCode !== 'string' || !uploadData.hashCode.trim()) {
    throw new Error((result && result.message) || (res && res.msg) || '图片上传失败，请重新上传');
  }
  return res;
}

export function offlineProductCase(data) {
  return post(`${prefix}/offline`, data);
}

export function deleteProductCase(data) {
  return post(`${prefix}/delete`, data);
}

export function getInternationalPublishAbility(data) {
  return post(`${prefix}/intl-ability`, data, { noMessage: true });
}

export function getInternationalMapping(data) {
  return post(`${prefix}/intl-mapping`, data);
}

export function prepareInternationalDraftSource(data) {
  return post(`${prefix}/prepare-intl-draft-source`, data);
}

export function getMainCategoryList(language) {
  return get(appendLanguage(`${mkLeadsUrl}/mk-leads/common/data-dict/main-category`, language));
}

export function getSubCategoryList(mainCategory, language) {
  return get(appendLanguage(`${mkLeadsUrl}/mk-leads/common/data-dict/sub-category/${mainCategory}`, language));
}

export function getCategoryMaterialList(mainCategory, language) {
  return get(appendLanguage(`${mkLeadsUrl}/mk-leads/common/data-dict/category-material/${mainCategory}`, language));
}

export function getDictByTypes(types, language) {
  return post(appendLanguage(`${mkLeadsUrl}/mk-leads/common/data-dict/get-dict-by-type`, language), (types || []).map(key => ({
    key,
    excludes: []
  })));
}
